import { createActionTypes } from '../../shared/actions';
import { failedAndSucceededNotIncluded } from '../../shared/utils';
import { ACTIONS_NAMESPACE } from '../../shared/constants';

export const typeClearAlert = 'CLEAR_ALERT';
export const typeClearDialog = 'CLEAR_DIALOG';
export const typeHideDialog = 'HIDE_DIALOG';
export const typeInvalidToken = 'INVALID_TOKEN';
export const typeLoadCatalogues = 'LOAD_CATALOGUES';
export const typeShowAlert = 'SHOW_ALERT';
export const typeShowDialog = 'SHOW_DIALOG';
export const typeVerifyToken = 'VERIFY_TOKEN';

export const typeCreateTableData = 'CREATE_TABLE_DATA';
export const typeDeleteTableData = 'DELETE_TABLE_DATA';
export const typeEditTableData = 'EDIT_TABLE_DATA';
export const typeExportTableData = 'EXPORT_TABLE_DATA';
export const typeLoadTableData = 'LOAD_TABLE_DATA';
export const typeReloadTableData = 'RELOAD_TABLE_DATA';

export const namespace = `${ACTIONS_NAMESPACE}/App`;

const clearAlert = createActionTypes(typeClearAlert, namespace);

const clearDialog = createActionTypes(typeClearDialog, namespace);

const createTableData = createActionTypes(typeCreateTableData, namespace);

const deleteTableData = createActionTypes(typeDeleteTableData, namespace);

const editTableData = createActionTypes(typeEditTableData, namespace);

const exportTableData = createActionTypes(typeExportTableData, namespace);

const hideDialog = createActionTypes(typeHideDialog, namespace, {
  ...failedAndSucceededNotIncluded
});

const invalidToken = createActionTypes(typeInvalidToken, namespace, {
  ...failedAndSucceededNotIncluded
});

const loadCatalogues = createActionTypes(typeLoadCatalogues, namespace);

const loadTableData = createActionTypes(typeLoadTableData, namespace);

const reloadTableData = createActionTypes(typeReloadTableData, namespace, {
  ...failedAndSucceededNotIncluded
});

const showAlert = createActionTypes(typeShowAlert, namespace);

const showDialog = createActionTypes(typeShowDialog, namespace);

const verifyToken = createActionTypes(typeVerifyToken, namespace);

export default {
  ...clearAlert,
  ...clearDialog,
  ...createTableData,
  ...deleteTableData,
  ...editTableData,
  ...exportTableData,
  ...hideDialog,
  ...invalidToken,
  ...loadCatalogues,
  ...loadTableData,
  ...showAlert,
  ...showDialog,
  ...verifyToken,
  ...reloadTableData
};



// WEBPACK FOOTER //
// ./src/containers/App/constants.js